<template>
    <div>
        <PageHeader :title="pageTitle">
            <template v-slot:icon>
                <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
            </template>
        </PageHeader>

        <div class="grid grid-cols-5 mb-6 gap-x-4 card p-12" v-if="!loadingEntireScreen">
            <div class="flex flex-col">
                <label class="label">Filtrar Data Inicial</label>
                <Datepicker locale="pt-BR" :enableTimePicker="false" format="dd/MM/yyyy" v-model="filter.start_date" autoApply @update:modelValue="loadData" />
            </div>
            <div class="flex flex-col">
                <label class="label">Filtrar Data Final</label>
                <Datepicker locale="pt-BR" :enableTimePicker="false" format="dd/MM/yyyy" v-model="filter.end_date" autoApply @update:modelValue="loadData" />
            </div>
        </div>

        <div class="flex justify-center mb-6" v-if="loading">
            <Loading text="Buscando Dados  Aguarde..." :show="loading" />
        </div>
        
        <Alert text="Ainda não existem reuniões realizadas para este cliente" :show="!meetings.length && !loading" />

        <div v-for="meeting in meetings" :key="meeting.id">
            <MeetingCard class="mt-4" :meeting="meeting" />
            <FileTable class="mt-2" v-if="meeting.files && meeting.files.length" :files="meeting.files" :delete-control="false" />
        </div>

    </div>
</template>

<script>

import { ref } from 'vue';
import Alert from '@/components/Alert';
import MeetingCard from '@/components/MeetingCard';
import FileTable from '@/components/FileTable';
import { defaultDate } from '../filters/date';
import { MeetingService, CompanyService } from '../services/Entity';
import Swal from 'sweetalert';
import { DateTime } from 'luxon';
import AuthService from '../services/AuthService';

export default {
    name: 'MeetingNotes',
    components: {
        Alert,
        MeetingCard,
        FileTable
    },
    setup() {
        const pageTitle = ref('Notas de Reunião');
        const page = ref(1);
        const limit = ref(50);
        const filter = ref({
            start_date: DateTime.now().minus({ days: 30 }),
            end_date: DateTime.now() 
        });
        const totalItens = ref(0);
        const loading = ref(false);
        const loadingEntireScreen = ref(false);
        const meetings = ref([]);
        const company = ref({});
        const loggedUser = AuthService.getAuthInfo();

        async function init() {
            loadingEntireScreen.value = true;
            await loadData()
            loadingEntireScreen.value = false;
        }

        async function loadData() {
            loading.value = true;            
            await getCompanyById(loggedUser.company);
            await loadMeetings();
            
            loading.value = false;
        }

        async function getCompanyById(companyId) {
            try {
                const { data } = await CompanyService.getById(companyId);

                company.value = data;
                pageTitle.value = `Notas de reunião`
            } catch(err) {
                loading.value = false;
                console.log(err);
                Swal({
                    title: 'Ocorreu um erro ao obter dados do cliente',
                    text: 'Atualize a página e tente novamente',
                    icon: 'error'
                });
            }
        }

        async function loadMeetings() {
            try {
                const listingFilter = { page: 1, limit: 9999 };
                const { data: { total, items }} = await MeetingService.list(listingFilter.page, listingFilter.limit);

                totalItens.value = total;
                meetings.value = items;
            } catch(err) {
                loading.value = false;
                console.log(err);
                Swal({
                    title: 'Ocorreu um erro ao obter dados dos colaboradores',
                    text: 'Atualize a página e tente novamente',
                    icon: 'error'
                });
            }
        }

        init();

        return {
            defaultDate,
            company,
            loadData,
            pageTitle,
            page,
            limit,
            filter,
            totalItens,
            loading,
            loadingEntireScreen,
            meetings
        }
    }
}
</script>
